import styled from 'styled-components'
import Flex from 'Components/Flex'
import AppLink from 'Components/AppLink'
import { TEXT_GREY } from '@CSSVars/colors'

export const _Locked = styled.div`
  position: relative;
  overflow: hidden !important;
  .imageholder {
    height: 100%;
  }
`

export const _LockedImgBox = styled.div`
  padding-bottom: 65%;
  margin-bottom: 12px;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  > div {
    position: absolute;
    height: 100%;
  }
  img {
    -webkit-backface-visibility: hidden;
    transform: translate3d(0,0,0);
  }
`

export const _PreviewContent = styled.div`
  position: relative;
  padding: 10px 0;

`
export const _AskingPrice = styled(Flex)`
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
`
export const _AddressHolder = styled.div`
  line-height: 22px;

`
export const _AddressTitle = styled.address`
  font-style: normal;
  line-height: 22px;
  color: ${TEXT_GREY};
`
export const _Link = styled(AppLink)`
  text-decoration: none;
  cursor: default;
`

export const _ListingRemovalMessageContainer = styled.div`
  margin-top: 4px;
`
